var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Promise from 'bluebird';
import { CacheLayer } from '@/central';
import { BaseService } from './BaseService';
var AssistantService = (function (_super) {
    __extends(AssistantService, _super);
    function AssistantService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AssistantService.prototype, "viewFields", {
        get: function () {
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssistantService.prototype, "fieldTitle", {
        get: function () {
            return 'Title';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssistantService.prototype, "fieldTeaser", {
        get: function () {
            return 'Schnellinfo';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssistantService.prototype, "fieldDate", {
        get: function () {
            return 'Created';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssistantService.prototype, "fieldEditDate", {
        get: function () {
            return 'Modified';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssistantService.prototype, "fieldCategory", {
        get: function () {
            return 'RUBKategorien';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssistantService.prototype, "urlWeb", {
        get: function () {
            return 'assistenten';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssistantService.prototype, "urlList", {
        get: function () {
            return 'Lists/AssistentenMaster';
        },
        enumerable: true,
        configurable: true
    });
    AssistantService.prototype.finalizeItem = function (item, spItem, categoryField, list, web, site) {
        item.tags = {};
        if (new Date(item.date) > new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 5)) {
            item.tags['neu'] = '#8DAE10';
        }
        item.url = web.get_serverRelativeUrl().replace(/\/+$/, '') + "/Seiten/assistenten.aspx?Assistent=" + item.id;
        return Promise.resolve(item);
    };
    AssistantService.prototype.finalizeItems = function (items, list, web, site) {
        return Promise.resolve(items);
    };
    AssistantService.prototype.loadAssistants = function (categoryGuid, sort, rowLimit) {
        var _this = this;
        if (rowLimit === void 0) { rowLimit = 100; }
        return CacheLayer.simpleLoad(function () {
            return _this.loadItems(categoryGuid, sort, rowLimit);
        }, "loadAssistants-" + categoryGuid + "-" + sort + "-" + rowLimit);
    };
    return AssistantService;
}(BaseService));
export { AssistantService };
